import React, { useState } from "react";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import LoginForm from "./components/LoginForm";
import MainScreen from "./components/MainScreen";
import AvailabilityCalendar from "./components/AvailabilityCalendar";
import UserProfile from "./components/UserProfile";

function Layout({ name, onLogout, children }) {
  return (
    <div className="max-w-2xl mx-auto p-2">
      <div className="flex justify-between items-center mb-4">
        <span className="font-bold text-lg">¡Hola {name}!</span>
        <button onClick={onLogout} className="btn btn-sm">
          Salir
        </button>
      </div>
      <div className="mb-4 flex gap-2">
        <Link to="/" className="btn bg-blue-600 px-2 py-1 text-white btn-primary btn-outline btn-sm">
          Partidos
        </Link>
        <Link to="/disponibilidad" className="btn bg-orange-600 px-2 py-1 text-white btn-outline btn-sm">
          Mi Disponibilidad
        </Link>
        <Link to="/perfil" className="btn bg-gray-600 px-2 py-1 text-white btn-outline btn-sm">
          Mi Perfil
        </Link>
      </div>
      <div>{children}</div>
    </div>
  );
}

function AppRoutes({ token, name, onLogout }) {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <Layout name={name} onLogout={onLogout}>
            <MainScreen token={token} />
          </Layout>
        }
      />
      <Route
        path="/disponibilidad"
        element={
          <Layout name={name} onLogout={onLogout}>
            <AvailabilityCalendar token={token} />
          </Layout>
        }
      />
      <Route
        path="/perfil"
        element={
          <Layout name={name} onLogout={onLogout}>
            <UserProfile token={token} />
          </Layout>
        }
      />
    </Routes>
  );
}

export default function App() {
  const [token, setToken] = useState(localStorage.getItem("token"));
  const [name, setName] = useState(localStorage.getItem("name"));

  function handleLogin(token, name) {
    setToken(token);
    setName(name);
    localStorage.setItem("token", token);
    localStorage.setItem("name", name);
  }
  function handleLogout() {
    setToken(null);
    setName(null);
    localStorage.removeItem("token");
    localStorage.removeItem("name");
  }

  if (!token) return <LoginForm onLogin={handleLogin} />;

  return (
    <BrowserRouter>
      <div className="min-h-screen bg-gray-100">
        <AppRoutes token={token} name={name} onLogout={handleLogout} />
      </div>
    </BrowserRouter>
  );
}